import type {
  FruitShopV2State,
  FruitShopV2ViewerPlayer,
  FruitShopV2ViewerState,
  MaskedFruitRoundResult,
} from "../types";

function maskResult(result: MaskedFruitRoundResult): MaskedFruitRoundResult {
  if (!result.hidden) {
    return result;
  }

  return {
    productId: result.productId,
    sellerCount: result.sellerCount,
    finalPriceWon: null,
    totalRevenueWon: null,
    winnerIds: null,
    payoutByPlayerId: null,
    hidden: true,
  };
}

function projectPlayer(
  state: FruitShopV2State,
  viewerId: string,
  playerId: string,
): FruitShopV2ViewerPlayer {
  const player = state.players.find(
    (candidate) => candidate.playerId === playerId,
  );
  if (!player) {
    throw new Error(`Unknown player: ${playerId}`);
  }

  const isSelf = player.playerId === viewerId;
  const isCompleted = state.status === "COMPLETED";

  return {
    playerId: player.playerId,
    ownFruitRights: isSelf ? player.fruitRights : null,
    totalIncomeWon: isCompleted ? player.totalIncomeWon : null,
    itemStatus: isSelf ? player.itemStatus : null,
  };
}

export function filterStateForViewer(
  state: FruitShopV2State,
  viewerId: string,
): FruitShopV2ViewerState {
  return {
    gameId: state.gameId,
    status: state.status,
    roundCount: state.roundCount,
    currentRound: {
      roundNumber: state.currentRound.roundNumber,
      phase: state.currentRound.phase,
      itemReadyPlayerIds: state.currentRound.itemReadyPlayerIds,
      market: state.currentRound.market,
      ownPriceSubmission: state.currentRound.priceSubmissions[viewerId] ?? null,
      priceSubmittedPlayerIds: Object.keys(state.currentRound.priceSubmissions),
      changeRecords: state.currentRound.changeRecords,
      productResults: state.currentRound.productResults.map(maskResult),
      confirmedPlayerIds: state.currentRound.confirmedPlayerIds,
    },
    players: state.players.map((player) =>
      projectPlayer(state, viewerId, player.playerId),
    ),
    winnerIds: state.winnerIds,
    lowestPlayerIds: state.lowestPlayerIds,
    garnetAwardsByPlayerId: state.garnetAwardsByPlayerId,
    lifeTokenAwardsByPlayerId: state.lifeTokenAwardsByPlayerId,
    extensionNumber: state.extensionNumber,
    hostPlayerId: state.hostPlayerId,
  };
}
